export default __webpack_public_path__ + "static/media/banner2.6c57898c.gif";